import * as React from "react";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import Glyphicon from "source/app/presentation/Shared/Glyphicon/Glyphicon";
import { StyleClassAuto } from "source/app/presentation/Shared/Styles/Auto/StyleClassAuto";

export function ProblemDreamMissingHashTag() {
    return (
        <span className={styleClass} data-tip="Problem hashtag required">
            <Glyphicon icon={EGlyphicon.alert} />
        </span>
    );
}

const styleClass = StyleClassAuto({ color: `coral`, marginLeft: `10px` });
